import React from 'react'
import { connect } from 'react-redux';
import { purchaseFetchPage } from '../../actions/purchaseAction';
import { consigneeUpdate, consigneeFetchUser } from '../../actions/consigneeAction'
import { Button, Modal, ModalBody, ModalFooter, FormGroup } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';

let userId = localStorage.getItem('tolaut@userId') || null
class ConsigneeTypeFlaseModals extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            trxlength: '',
            modal:true,
            consignee_type:''
        }
    }
    componentDidMount(){
        const data = {
            length: 10,
            start : 0,
            consignee_id: userId,
        }
        this.props.purchaseFetchPage(data)
    }
    componentDidUpdate = async(prevProps) =>{
        // if(prevProps.isSuccess !== this.props.isSuccess){
        //     if(this.props.purchases){
        //         this.setState({trxlength: this.props.purchases.data.length})
        //     }
        // }
        if(prevProps.updateSuccess !== this.props.updateSuccess){
            if(this.props.consigneeAddSuccessVal){
                if(this.props.consigneeAddSuccessVal.success){
                    alert('Update sukses, terima kasih !')
                    if(this.state.consignee_type === 0){
                        localStorage.setItem('tolaut@consignee_type', 'Berangkat')
                    }else{
                        localStorage.setItem('tolaut@consignee_type', 'Balik')
                    }
                    window.location.reload()
                }else{
                    alert('Tipe consignee sudah ada !')
                    await this.props.consigneeFetchUser(userId)
                }
            }
        }
        if(prevProps.profileisSuccess !== this.props.profileisSuccess){
            if(this.props.profile){
                await localStorage.setItem('tolaut@consignee_type', this.props.profile.data[0].consignee_type)
                window.location.reload()
            }
        }
    }
    toggle = () =>  this.setState({modal: false});
    handleUpdateTipeConsignee = (event, values) => {
        this.setState({...this.state, consignee_type: parseInt(values.consignee_type)})
        values.consignee_type = parseInt(values.consignee_type)
        values.id = parseInt(userId)
        this.props.consigneeUpdate(values)
    }
    ModalsV = () => {
        return (
            <Modal isOpen={this.state.modal} >
            <ModalBody>
                {localStorage.getItem('tolaut@consignee_type') === 'null' &&
                  <> 
                   <p>Akun Consignee anda belum memiliki jenis akun, Mohon dapat dipilih untuk tipe dibawah ini.</p>
                   <AvForm onValidSubmit={this.handleUpdateTipeConsignee}>
                        <AvField type="select" name="consignee_type" label="Tipe Consignee" required>
                            <option value=''></option>
                            <option value={0}>Berangkat</option>
                            <option value={1}>Balik</option>
                        </AvField>
                        {' '}
                        <FormGroup>
                            <Button color="primary" disabled={this.props.updateLoading} type='submit'>Submit</Button>
                        </FormGroup>
                    </AvForm>
                  </>
                }
                <p></p>
                {/* {this.state.trxlength === 0 &&  */}
                    <>
                        <h3><b> Keterangan: </b></h3>
                        <p>
                        - Consignee Berangkat adalan akun consignee yang perusahaannya berdomisili di wilayah Tertinggal, Terpencil, Terluar dan Perbatasan (3TP).
                        </p>
                        <p>
                        - Consignee Balik adalah akun consignee yang perusahaannya berdomisili di wilayah kota-kota besar dan diluar daerah dari wilayah 3TP.
                        </p>
                    </>
                {/* } */}
            </ModalBody>
            {/* {this.state.trxlength === 0 && */}
                {/* <ModalFooter>
                    {localStorage.getItem('tolaut@consignee_type') === 'null' ?
                        <Button color="secondary" disabled>Close</Button>
                    :
                        <Button color="secondary" onClick={this.toggle}>Close</Button>
                    }
                </ModalFooter> */}
            {/* } */}
        </Modal>
        )
    }
    
    render(){
        // console.log(localStorage.getItem('tolaut@consignee_type'))
        // if(localStorage.getItem('tolaut@consignee_type') === 'null' && this.state.trxlength === 0){
        //     return(
        //        this.ModalsV()
        //     )
        // }else 
        if(localStorage.getItem('tolaut@consignee_type') === 'null'){
            return (
                this.ModalsV()
            )
            // return false
        }
        // else if(this.state.trxlength === 0){
        //     return (
        //         this.ModalsV()
        //     )
        // }
        else{
            return false
        }
    }
}

const mapStateToProps = (state) => {
    return {
      purchases: state.purchases.purchases,
      isSuccess: state.purchases.purchaseGetSuccess,
      hasError: state.purchases.purchaseGetError,
      isLoading: state.purchases.purchaseGetLoading,

      profile: state.consignees.consignee,
      profileisSuccess: state.consignees.consigneeViewSuccess,
      profilehasError: state.consignees.consigneeViewError,
      profileisLoading: state.consignees.consigneeViewLoading,
    
      consigneeAddSuccessVal : state.consignees.consigneeAddSuccessVal,
      updateSuccess: state.consignees.consigneeAddSuccess,
      updateError: state.consignees.consigneeAddError,
      updateLoading: state.consignees.consigneeAddLoading,
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
      purchaseFetchPage: (item) => dispatch(purchaseFetchPage(item)),
      consigneeUpdate: (parent) => dispatch(consigneeUpdate(parent)),
      consigneeFetchUser: (parent) => dispatch(consigneeFetchUser(parent))
    }
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(ConsigneeTypeFlaseModals)